import React from 'react';
import { useTheme } from '../../context/ThemeContext';
import { Outlet } from 'react-router-dom';

const LayoutAuth = ({ children }) => {
  const { theme } = useTheme();

  return (
    <div className={`layout-auth ${theme}`}>
      <div className="auth-container">
        <Outlet />
      </div>
    </div>
  );
};

export default LayoutAuth; 